// Gradient image placeholder shown when a startup has no uploaded logo.
// Uses per-instance gradient ids so multiple copies on one page don't collide.
import React from 'react';

const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7852F8" />
    <stop offset="1" stopColor="#84AEF6" />
  </>
);

const StartupLogoPlaceholderIcon = ({ size = 72 }) => {
  const uid = React.useId();
  const g = (n) => `slp_${uid}_${n}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="70" height="70" rx="15" stroke={`url(#${g(0)})`} strokeWidth="2" />
      <rect x="20" y="22" width="32" height="28" rx="5" stroke={`url(#${g(1)})`} strokeWidth="2" />
      <circle cx="29" cy="30" r="3" fill={`url(#${g(2)})`} />
      <path d="M20 49L29 38L35 44L44 34L52 49H20Z" fill={`url(#${g(3)})`} />
      <path
        d="M57 20V10M61 14L57 10L53 14"
        stroke={`url(#${g(4)})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id={g(0)} x1="-18" y1="18" x2="54" y2="90" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(1)} x1="10.5" y1="28.5" x2="40.2665" y2="62.2354" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(2)} x1="24.5" y1="28.5" x2="30.5" y2="34.5" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(3)} x1="12" y1="37.75" x2="23.5292" y2="62.3457" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(4)} x1="51" y1="12.5" x2="60.7561" y2="20.3049" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StartupLogoPlaceholderIcon;
